import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/de'

export default defineNuxtPlugin(() => {
  dayjs.extend(customParseFormat)
  dayjs.extend(duration)
  dayjs.extend(utc)
  dayjs.extend(timezone)

  dayjs.tz.setDefault('Europe/Berlin')
  dayjs.locale('de')
})
